import useGetLoggedInUser from "hooks/useGetLoggedInUser";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Celebration } from "@outpave/ds";
import { useTranslation } from "react-i18next";

const BIRTHDAY_BANNER_KEY = "birthdayBannerLastShown";

/** How long the banner stays up, ms. */
const BANNER_DURATION = 7000;

function isToday(dateString: string) {
  const today = new Date().toLocaleDateString();
  return today === dateString;
}

const BirthdayBanner: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useGetLoggedInUser();

  const [show, setShow] = useState(false);

  const name = user?.firstName;

  useEffect(() => {
    if (user && user.isBirthday) {
      const lastShown = localStorage.getItem(BIRTHDAY_BANNER_KEY);
      if (!lastShown || !isToday(lastShown)) {
        setShow(true);
        localStorage.setItem(
          BIRTHDAY_BANNER_KEY,
          new Date().toLocaleDateString(),
        );
      }
    }
  }, [user]);

  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => setShow(false), BANNER_DURATION);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  if (!show) return null;

  return (
    <>
      {/* The burst reads the live brand colours, so a white-label shell
          celebrates in its own palette. */}
      <Celebration active={show} />
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: (theme) => theme.zIndex.snackbar,
          background:
            "linear-gradient(90deg, var(--color-brand-300) 0%, var(--color-brand-500) 100%)",
          color: "var(--color-text-on-brand)",
          textAlign: "center",
          paddingBlock: "var(--space-5)",
          animation: "slideDown 0.7s cubic-bezier(.4,2,.6,1) both",
          "@keyframes slideDown": {
            from: { transform: "translateY(-100%)", opacity: 0 },
            to: { transform: "translateY(0)", opacity: 1 },
          },
        }}
      >
        <Typography variant="h4" sx={{ color: "inherit" }}>
          {t("Happy Birthday")}, {name}!
        </Typography>
      </Box>
    </>
  );
};

export default BirthdayBanner;
